import styled from "styled-components";

export const TitleDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Logo = styled.img`
    width: 115px;
    height: 24px;
    margin-right: 8px;
`;

export const TitleText = styled.div`
    color: var(--White, #fff);
    font-size: 18px;
    font-weight: 500;
`;